import { Hotel } from "lucide-react";
import type { INavItem } from "@/models/INavItem";
import { HotelRoutes } from "./routes";
import { HotelPermissions } from "./permissions";

export const hotelNav: INavItem = {
  labelKey: "nav.hotels",
  icon: Hotel,
  path: HotelRoutes.LIST,
  permissions: [HotelPermissions.READ],
};
